import { render, staticRenderFns } from "./EpLinkList.vue?vue&type=template&id=45ba4072&scoped=true&"
import script from "./EpLinkList.vue?vue&type=script&lang=js&"
export * from "./EpLinkList.vue?vue&type=script&lang=js&"
import style0 from "./EpLinkList.vue?vue&type=style&index=0&id=45ba4072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba4072",
  null
  
)

export default component.exports